import React from 'react';
import { images } from '../../data/images';
import { Button } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
const audiences = [{
  id: 'candidates',
  title: 'Explore Your Next Opportunity.',
  text: 'Confidential conversations about your career, introductions only with your permission, and honest guidance at every stage.',
  points: ['Confidential registration', 'Executive transition support', 'Interview and CV guidance'],
  image: images.candidate,
  alt: 'A professional woman reviewing notes beside an office window',
  cta: {
    label: 'Candidate support',
    to: '/candidates'
  },
  secondary: {
    label: 'Find jobs',
    to: '/jobs'
  }
}, {
  id: 'employers',
  title: 'Build Your Leadership Team.',
  text: 'Research-led searches, structured assessment and discreet handling of the appointments that shape your organisation.',
  points: ['Executive and specialist search', 'Talent mapping', 'Flexible engagement models'],
  image: images.executiveWindow,
  alt: 'A senior executive looking out over a city from an office window',
  cta: {
    label: 'Hire talent',
    to: '/employers'
  },
  secondary: {
    label: 'Our services',
    to: '/services'
  }
}];
export function AudienceSplit() {
  return <section className="bg-ivory py-24 md:py-32" data-id="element-142" data-mp="3uogz0eqpm72z">
      <div className="container-page grid gap-8 lg:grid-cols-2" data-id="element-143" data-mp="2kek3848rtdz">
        {audiences.map((a, i) => <Reveal key={a.id} delay={i * 0.05} className="h-full" data-id="element-144" data-mp="31zrxielqrzqp" data-mpi={i}>
            <article className="flex h-full flex-col overflow-hidden rounded-xl border border-line bg-white" data-id="element-145" data-mp="36y36kn47q67v">
              <img src={a.image} alt={a.alt} loading="lazy" className="aspect-[16/10] w-full object-cover" data-id="element-146" data-mp="3azy73pebkfkl" />
              <div className="flex flex-1 flex-col p-8 md:p-10" data-id="element-147" data-mp="3fzass6tgfgll">
                <p className="text-sm font-medium text-gold-700" data-id="element-148" data-mp="3fwonyexy7f72">{a.id === 'candidates' ? 'For candidates' : 'For employers'}</p>
                <h2 className="mt-3 font-display text-4xl font-semibold leading-tight text-ink" data-id="element-149" data-mp="v8aeg66c997l">{a.title}</h2>
                <p className="mt-4 leading-relaxed text-muted" data-id="element-150" data-mp="2rax8glv1v584">{a.text}</p>
                <ul className="mt-6 space-y-2" data-id="element-151" data-mp="2na3jrq9s9me6">
                  {a.points.map(p => <li key={p} className="flex items-center gap-3 text-ink" data-id="element-152" data-mp="2ncg2i5nd80sa">
                      <span className="h-1.5 w-1.5 rotate-45 bg-gold" aria-hidden="true" data-id="element-153" data-mp="31936gsdqjr7p" />
                      {p}
                    </li>)}
                </ul>
                <div className="mt-auto flex flex-wrap gap-3 pt-8" data-id="element-154" data-mp="28lqlgmn83rgi">
                  <Button to={a.cta.to} variant="navy" arrow data-id="element-155" data-mp="23mvsirvjkmio">
                    {a.cta.label}
                  </Button>
                  <Button to={a.secondary.to} variant="outline" data-id="element-156" data-mp="2ibs9jefkt9vf">
                    {a.secondary.label}
                  </Button>
                </div>
              </div>
            </article>
          </Reveal>)}
      </div>
    </section>;
}